// The rules four inputs apply to what was typed (backfill PR 32): the cart's quantity field
// (CartScreen), the multi-select lists of the keycap and legend editors (KeycapEditScreen's
// switch compatibility and LegendsEditScreen's supported layouts, one copy each until PR 32),
// the product editor's price in the German format (ProductEditScreen) and the shipping
// modal's used transfer film per order item (the ship dialog's film field and request, through
// utils/orderList.js since Oct 2026), and the customizer's quantity field (chain 8, Oct 2026).

const MAX_CART_QUANTITY = 100; // the limit of sets per cart item, applied by the two quantity fields (the cart reducer's sum passes it: KNOWN_BUGS.md's limit entry)

export const cartQuantityFromInput = (value) => {
  const parsed = Math.floor(Number(value)); // the field's number as the browser reads it (an exponent such as 1e3 included; parseInt stopped at the e until PR 32's review), its whole part
  const newQuantity = isNaN(parsed) ? 1 : Math.max(1, parsed); // Ensure quantity is a valid positive integer
  return Math.min(MAX_CART_QUANTITY, newQuantity); // Limit the quantity to 100
}; // the quantity the cart stores for what the quantity field holds when it loses focus

export const addSelectedOptions = (current, selectedOptions) => {
  // creates a new set from the current state to avoid duplicates:
  const newSelections = new Set(current);
  Array.from(selectedOptions).forEach((option) => {
    if (newSelections.has(option.value)) {
      return;
    } else {
      newSelections.add(option.value); // adds new selection
    }
  });

  return Array.from(newSelections); // converts the Set back to an array
}; // the list with the options selected in a multi-select added once each (a selection never removes an entry: the lists' tags do)

export const parsePriceInput = (raw) => {
  let normalizedUnitGross = raw.trim(); // Remove extra spaces

  normalizedUnitGross = normalizedUnitGross
    .replace(/[^0-9,]/g, '')
    .replace(',', '.'); // Convert German Format to english, by replacing ',' with '.'

  return parseFloat(normalizedUnitGross); // Convert to float
}; // the number the product editor saves for a price typed in the German format (1.234,56), NaN when nothing numeric is left

export const customizerQuantityLimit = (stock) =>
  Math.min(MAX_CART_QUANTITY, stock); // the most sets the customizer's quantity field takes, its max attribute: the limit per cart item or the layout's stock in the design's profile, whichever is lower (the attribute carried the stock alone until a chain 8 review, so the spinner ran past what the blur kept); NaN for a profile without a stock entry: Known bug (KNOWN_BUGS.md, a dropped profile)

export const customizerQuantityFromInput = (value, stock) =>
  Math.min(cartQuantityFromInput(value), customizerQuantityLimit(stock)); // the quantity the customizer stores for what its quantity field holds when it loses focus: the cart's rule (1 to 100, the whole part, 1 for anything but a number) capped at the layout's stock in the design's profile. CustomizerScreen's blur held a copy until chain 8 that read parseInt (a typed exponent stored 1) and had no cap at 100 (with 500 in stock it let 150 sets through: the limit entry of KNOWN_BUGS.md, which now names the cart reducer's sum alone). The result is NaN for a profile the layout no longer lists (Math.min with undefined) and 0 for a sold-out one: Known bug (KNOWN_BUGS.md, a dropped profile)

export const usedFilmQuantity = (value) =>
  Math.max(0, Math.floor(Number(value) || 0)); // the used transfer film an input holds: a whole number, at least 0, 0 for anything but a number
